import React from 'react'

interface CalculatorIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Calculator icon component
 *
 * Displays a calculator icon with customizable size and color.
 * Used for calculate actions and mathematical operations.
 */
const CalculatorIcon: React.FC<CalculatorIconProps> = ({
  size = 24,
  color = '#e3e3e3',
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${size}px`}
      viewBox='0 -960 960 960'
      width={`${size}px`}
      fill={color}
      className={className}
    >
      <path d='M320-240h60v-80h80v-60h-80v-80h-60v80h-80v60h80v80Zm200-30h200v-60H520v60Zm0-100h200v-60H520v60Zm44-152 56-56 56 56 42-42-56-58 56-56-42-42-56 56-56-56-42 42 56 56-56 58 42 42Zm-314-70h200v-60H250v60Zm-50 472q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' />
    </svg>
  )
}

export default CalculatorIcon
